import {CreditCard} from 'lucide-react';

const brands = [
  [/\be?\s*cash\s*app\b/i,'cash-app'], [/\bchime\b/i,'chime'],
  [/\bapple\s*pay\b/i,'apple-pay'], [/\bg(?:oogle)?\s*pay\b/i,'google-pay'],
  [/\bpay\s*pal\b/i,'paypal'], [/\bvenmo\b/i,'venmo'],
  [/\b(bitcoin|btc)\b/i,'bitcoin'], [/\b(usdt|tether)\b/i,'usdt'],
  [/\b(crypto(?:currency)?|usdc|ethereum|litecoin|blockchain)\b/i,'crypto'],
];

export function PaymentMark({method,large=false}) {
  const normalized=(method||'').replace(/[_-]/g,' ');
  const asset=brands.find(([pattern])=>pattern.test(normalized))?.[1];
  const svg=asset==='bitcoin'||asset==='usdt';
  const size=large?'h-12 w-12':'h-8 w-8';
  if(!asset)return <span aria-hidden="true" className={size+' inline-flex shrink-0 items-center justify-center rounded-lg bg-white/10 text-gray-200'}><CreditCard size={20}/></span>;
  return <img src={svg?'/payment-logos/'+asset+'.svg':'/payment-logos/hd/'+asset+'.webp'} alt="" decoding="async"
    width={large?48:32} height={large?48:32} className={size+' shrink-0 rounded-lg object-contain'}/>;
}

export default function PaymentBrand({method}) {
  return <span className="inline-flex min-w-0 max-w-full items-center gap-2 align-middle">
    <PaymentMark method={method}/>
    <span className="min-w-0 break-words [overflow-wrap:anywhere]">{method||'Unknown method'}</span>
  </span>;
}
